import { combineReducers } from 'redux';
import { appRoutes } from './routes';

export const initReducers = () => {
  return {};
};

export const initRoutes = () => {
  return appRoutes;
};

export const initApp = (store) => {
};
